// extracted by mini-css-extract-plugin
module.exports = {"DataContent":"OverallRating_DataContent__2uM4Q"};